var _templateObject, _path, _path2, _g, _g2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from '@emotion/styled';
import MUISvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';
import * as React from "react";
var SvgIcon = styled(MUISvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    stroke-width: 1px;\n    vector-effect: non-scaling-stroke;\n  }\n"])), svgIconClasses.root, function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return size && theme.size[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return size && theme.size[size];
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color && theme.color[color];
});
var SvgEmojiMeh = function SvgEmojiMeh(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E2D2",
    d: "M7.168 39.145A6.32 6.32 0 0 1 .854 32.83v-20.25c0-1.683.704-3.313 1.981-4.59l5.156-5.155C9.268 1.558 10.898.854 12.581.854h20.25a6.32 6.32 0 0 1 6.313 6.314v20.25c0 1.682-.704 3.312-1.98 4.59l-5.156 5.155c-1.296 1.297-2.884 1.982-4.59 1.982z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F0F0F",
    d: "M32.832 1.71A5.46 5.46 0 0 1 38.29 7.17v20.25c0 1.573-.698 2.953-1.73 3.985l-5.156 5.156c-1.042 1.042-2.412 1.73-3.985 1.73H7.169a5.46 5.46 0 0 1-5.459-5.458v-20.25c0-1.573.705-2.96 1.73-3.986L8.598 3.44c1.035-1.035 2.412-1.73 3.985-1.73zm0-1.71h-20.25c-1.91 0-3.756.792-5.195 2.231L2.231 7.387C.793 8.826 0 10.671 0 12.582v20.25C0 36.785 3.216 40 7.168 40h20.25c1.911 0 3.756-.792 5.195-2.231l5.156-5.156C39.208 31.174 40 29.33 40 27.42V7.169C40 3.216 36.784 0 32.832 0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0F0F0F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.033 26.856a1.227 1.227 0 1 0 0-2.454 1.227 1.227 0 0 0 0 2.454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.033 24.915a.714.714 0 1 1 0 1.429.714.714 0 0 1 0-1.429m0-1.026c-.96 0-1.74.78-1.74 1.74s.78 1.74 1.74 1.74 1.74-.78 1.74-1.74-.78-1.74-1.74-1.74"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#0F0F0F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.612 26.856a1.227 1.227 0 1 0 0-2.454 1.227 1.227 0 0 0 0 2.454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.613 24.915a.714.714 0 1 1 0 1.429.714.714 0 0 1 0-1.429m0-1.026c-.96 0-1.74.78-1.74 1.74s.78 1.74 1.74 1.74 1.74-.78 1.74-1.74-.78-1.74-1.74-1.74"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F0F0F",
    d: "M21.194 30.01H9.454a.684.684 0 0 1 0-1.367h11.74a.684.684 0 0 1 0 1.367"
  }))));
};
export default SvgEmojiMeh;